import { useContext } from 'react';

import emptyDashboard from '@atom/images/emptyDashboard.svg';
import { Button } from '@atom/mui';
import colors from '@atom/styles/colors';

import DashboardContext from './DashboardContext';
import DashboardCustomizeIcon from './DashboardCustomizeIcon';

import classes from './dashboardEmptyState.module.css';

const styles = {
  blueButton: {
    backgroundColor: colors.brand.blue,
    color: colors.neutral.white,
    padding: '0.5rem 1rem',
  },
};

const DashboardEmptyState = () => {
  const { setShowCustomize } = useContext(DashboardContext);
  return (
    <div className={classes.emptyDashboardContainer}>
      <img src={emptyDashboard} />
      <div className={classes.emptyDashboardTitle}>
        Start building your dashboard
      </div>
      <div className={classes.emptyDashboardSubtitle}>
        Your home dashboard is ready to take off! Customize it with cards to see
        what's important and keep your day on track.
      </div>
      <Button
        style={styles.blueButton}
        onClick={() => setShowCustomize(true)}
        startIcon={<DashboardCustomizeIcon />}
        data-cy="dashboardEmptyCustomizeIcon"
      >
        Customize
      </Button>
    </div>
  );
};

export default DashboardEmptyState;
